import { Navigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

type DecodedToken = {
  id: string;
  email: string;
  role: string;
  exp: number;
  iat: number;
};

export function EcosystemHeadProtectedRoute() {
  const location = useLocation();
  const token = Cookies.get("token");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      Cookies.remove("token");
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (decoded.role === "ADMIN" || decoded.role === "SUB_ADMIN") {
      return <Navigate to="/admin/companies" replace />;
    }

    if (decoded.role === "FACILITATOR") {
      return <Navigate to="/facilitator/dashboard" replace />;
    }

    if (decoded.role === "CLIENT" || decoded.role === "MANAGER") {
      return <Navigate to="/dashboard" replace />;
    }

    if (decoded.role !== "ECOSYSTEM_HEAD") {
      Cookies.remove("token");
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
  } catch {
    Cookies.remove("token");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
}
